import React from 'react';
import styled from 'styled-components';
import Button from './Button';
import { Path } from '../../Routing';
import { Trans, useTranslation } from 'react-i18next';
import { itvThemeColor, themeColor } from '../../Theming';
import ButtonTextGroup from './ButtonTextGroup';
import {
  ActivationButtonStatusMsg,
  getActivateButtonLink,
  getActivationButtonStatusMsg,
  getDownloadButtonLink,
  onActivateButtonClick,
} from '../utils';

const Container = styled.div``;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30px;
  padding-inline: 24px;
`;

const ButtonContainer = styled.div`
  padding-inline: 24px;
`;

const DownloadAppMsg = styled.span`
  color: ${themeColor('black')};
  font-size: 14px;
  line-height: 120%;
  font-family: Arial;
  padding-inline: 24px;
  display: flex;
`;

const StatusMsgContainer = styled.div`
  position: relative;
  margin-top: 27px;
  padding-inline: 24px;
`;

const StatusMsgContent = styled.div`
  display: flex;
  flex-direction: row;
  padding-block: 8px;
  background-color: ${itvThemeColor('gray')};
  border-radius: 5px;
`;

const StatusMsg = styled.span`
  display: block;
  font-family: Arial;
  font-size: 14px;
  line-height: 120%;
  padding-right: 10px;
`;

const Triangle = styled.div<{
  buttonType: ActivationButtonStatusMsg['button'];
}>`
  position: absolute;
  right: ${(props) => (props?.buttonType === 'DOWNLOAD' ? '60px' : undefined)};
  left: ${(props) => (props?.buttonType === 'ACTIVATE' ? '60px' : undefined)};
  top: -20px;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 30px solid ${itvThemeColor('gray')};
`;

const InfoIcon = styled.span`
  margin-inline: 8px;
`;

const ActivateCashSaverInfoContainer = styled.div`
  padding-left: 24px;
  padding-right: 10px;
  padding-top: 10px;
`;
const ActivateCashSaverInfo = styled.span`
  font-family: Arial;
  font-size: 14px;
  line-height: 120%;

  &.cashsaver-info-underlined {
    text-decoration: underline;
  }
`;

interface ActivationButtonsProps {
  isEmbeddedInAndroid?: boolean;
}
const ActivationButtons: React.FC<ActivationButtonsProps> = ({
  isEmbeddedInAndroid,
}) => {
  const { t } = useTranslation();
  const buttonStatusMsg = getActivationButtonStatusMsg(t);

  if (isEmbeddedInAndroid) {
    return (
      <>
        <ButtonContainer>
          <a href={Path.PluginActivationReviewPermissionsV2}>
            <Button
              className="itvTheme"
              id="itv-activate-button"
              style={{ height: 42 }}
            >
              {t('extension.itvActivation.cashSaver.activateCashSaver')}
            </Button>
          </a>
        </ButtonContainer>

        <ActivateCashSaverInfoContainer>
          <ActivateCashSaverInfo className="cashsaver-info-wrapper">
            <Trans
              i18nKey={'extension.itvActivation.cashSaver.cashSaverInfo'}
              t={t}
            >
              <ActivateCashSaverInfo className="cashsaver-info-underlined" />
            </Trans>
          </ActivateCashSaverInfo>
        </ActivateCashSaverInfoContainer>
      </>
    );
  }
  return (
    <Container>
      <DownloadAppMsg>
        {t('extension.itvActivation.cashSaver.downloadAppMsg')}
      </DownloadAppMsg>

      <ButtonsContainer>
        <ButtonTextGroup
          href={getActivateButtonLink()}
          width="45%"
          title={t('extension.itvActivation.cashSaver.haveOurApp')}
          buttonText={t('extension.itvActivation.cashSaver.activate')}
        />
        <ButtonTextGroup
          href={getDownloadButtonLink()}
          width="45%"
          title={t('extension.itvActivation.cashSaver.needOurApp')}
          buttonText={t('extension.itvActivation.cashSaver.download')}
        />
      </ButtonsContainer>

      {buttonStatusMsg?.button && (
        <StatusMsgContainer>
          <Triangle buttonType={buttonStatusMsg.button} />
          <StatusMsgContent>
            <InfoIcon>&#9432;</InfoIcon>
            <StatusMsg>{buttonStatusMsg.msg}</StatusMsg>
          </StatusMsgContent>
        </StatusMsgContainer>
      )}
    </Container>
  );
};

export default ActivationButtons;
